// Personal Life Data Configuration
export const hobbies = [
  {
    emoji: '🎮',
    title: 'Gaming',
    description: 'Strategy & shooters — love systems thinking in game design.'
  },
  {
    emoji: '📚',
    title: 'Reading',
    description: 'Psychological thrillers, behavioral science & emerging tech.'
  },
  {
    emoji: '🎸',
    title: 'Music',
    description: 'Rock, metal & acoustic sessions — guitar is my reset button.'
  },
  {
    emoji: '⚽',
    title: 'Football',
    description: 'Weekend matches & Champions League nights.'
  },
  {
    emoji: '✈️',
    title: 'Travel',
    description: 'Exploring cultures, food, and architecture — curiosity outside code.'
  },
  {
    emoji: '🍳',
    title: 'Cooking',
    description: 'Experimenting like a lab — controlled chaos with flavor.'
  }
];

export const gameCategories = [
  {
    title: "Fortnite",
    category: "Casual",
    image: "https://cdn2.unrealengine.com/cdn-uploader-FN_OG_39-00_C1S7_IceKing_LiteIce_LL_KeyArt_BR_DiscoverTile_-480x270-18f5ddb6.jpg", // Fortnite logo/artwork :contentReference[oaicite:0]{index=0}
    multiplayer: true
  },
  {
    title: "EAFC",
    category: "Sports",
    image: "https://drop-assets.ea.com/images/W7jZ4vGojPtXKtHG0UAQQ/5e4c25d06e2346d2ef1f0db4e130b812/ea-primary-fc-logo-hero-med.svg", // FIFA cover art (Amazon CDN — commonly available for promotional use)
    multiplayer: true
  },
  {
    title: "Rocket League",
    category: "Casual",
    image: "https://preview.redd.it/when-did-they-change-the-rocket-league-logo-v0-z2e6qkaekcb11.png?width=300&format=png&auto=webp&s=60a025969f46e7935898e6fb7e0e284048f0b6fc", // Rocket League cover art from Wikimedia :contentReference[oaicite:1]{index=1}
    multiplayer: true
  },
  {
    title: "Split Fiction",
    category: "Story",
    image: "https://drop-assets.ea.com/images/19RgnhpZTm7ju1FQzg3xg8/95c8684d74d6e728903b59b86f325674/SPLIT_FICTION_LOGOTYPE_horizontal_white_1080-_1_.png", // Promotional art via Epic store (unofficial CDN proxy)
    multiplayer: true
  }
];

export const musicGenres = [
  'lo-fi',
  'synthwave',
  'ambient',
  'rock',
  'alternative',
  'progressive',
  'post-rock',
  'rnb',
  'metal'
];

// Playlist URLs - Configure with actual Spotify/Deezer links
export const playlists = [
  {
    platform: 'Spotify',
    url: 'https://open.spotify.com/playlist/2Q0ibmGvOgvVbFI94MdHS3?si=g3qZF9TTQK2ZCJ4yEkVKcw',
    accent: '#1DB954',
    text: "Curated by a close friend — my go-to mix for late-night coding sessions and deep problem-solving sprints."
  },
  {
    platform: 'Deezer',
    url: 'https://link.deezer.com/s/32Aa6ucTWrBY339gBcQ8U',
    accent: '#A238FF',
    text: "Desi gaane & nostalgic classics — the soundtrack that keeps me connected to my roots."
  }
];